<script>
  import {
    Breadcrumb,
    BreadcrumbItem,
    Loader,
    Page,
  } from "@gl/design-system";
  import { AppsRepository } from "../../repositories/index";
  import { navigate } from "../../utils/index";
  import { Layout } from "../../components/index";
  import { onMount, getContext } from "svelte";
  import { _ } from "../../stores/index";
  import ApplicationMembers from "./ApplicationMembers.svelte";

  export let id;

  let app = {};
  let loading = true;

  const basepath = "applications";
  let selectedTab = "members";

  const setSelectedTabFromPathname = () => {
    const path = decodeURIComponent(window.location.pathname);

    // find tab item
    if (path.includes("policies")) {
      selectedTab = "policies";
    } else {
      selectedTab = "members";
    }
  };

  async function fetchApp() {
    try {
      loading = true;

      app = await AppsRepository.getApplication(id);
    } finally {
      loading = false;
    }
  }

  onMount(() => {
    fetchApp();
    setSelectedTabFromPathname();
  });
</script>

{#if !loading}
  <Layout selected="applications" fillHeight>
    <Page>
      <Breadcrumb slot="breadcrumb">
        <BreadcrumbItem
          on:click={() => navigate("/applications")}
          on:keypress={(e) => {
            if (e.key === "Enter") navigate("/applications");
          }}>{$_("common.apps")}</BreadcrumbItem
        >
        <BreadcrumbItem current>
          {$_("common.app")}: {app.data.name}
        </BreadcrumbItem>
      </Breadcrumb>

      <h3 slot="header" class="gl-title level-3">
        {$_("common.app")}: {app.data.name}
      </h3>

      <div class="tab-content">
        <ApplicationMembers {id} {app} />
      </div>
    </Page>
  </Layout>
{:else}
  <Loader />
{/if}
